// extracted by mini-css-extract-plugin
export var radioInputRow = "B_sG";
export var radioInputColumn = "B_sH";
export var inputOptionRow = "B_qj";
export var inputOptionColumn = "B_qk";